"use strict";

var get = require('lodash.get');
var jwtDecode = require('jwt-decode');
var decode = function decode(token) {
  try {
    return jwtDecode(token);
  } catch (err) {
    return {};
  }
};
var makeGetDecodedToken = function makeGetDecodedToken(_ref) {
  var getToken = _ref.getToken;
  return function (options) {
    var refetch = get(options, 'refetch');
    return getToken({
      refetch: refetch
    }).then(decode);
  };
};
module.exports = {
  makeGetDecodedToken: makeGetDecodedToken
};